var map = {
	"./image1.png": "tJ3u",
	"./image10.png": "hhjL",
	"./image11.png": "84Nz",
	"./image12.png": "e/pu",
	"./image2.png": "PK0/",
	"./image3.png": "obEc",
	"./image4.png": "nRYp",
	"./image5.png": "xRE8",
	"./image6.png": "voUp",
	"./image7.png": "yw6V",
	"./image8.png": "hSrF",
	"./image9.png": "EfOg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wIt4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instruction_images \.(png|jpe?g|gif|svg)$
// module id = wIt4
// module chunks = 0